<template>
  <div id="adduser" class="Content-Page">
    <div id="namePage" class="wrap-Main">
      <div class="box-S4 flex-between-center">
        <div class="N-Page T-size-36">Add User</div>
      </div>
    </div>
    <div id="userContent" class="wrap-Main">
      <div class="box-S4 flex-between noPadding">
        <div class="box-S2">
          <div class="B-carddetail">
            <div class="panal-title">Display</div>
            <div class="b-row">
              <div class="b-display">
                <div class="B-display"></div>
              </div>
            </div>
            <div class="b-row">
              <v-btn class="theme-btn-even btn-upload center w100">
                <span class="I-upload"></span>
                <span class="T-size-18">Upload Photo</span>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="box-S2">
          <div class="B-carddetail">
            <div class="panal-title">Username</div>
            <div class="b-row">
              <v-text-field label="Username"></v-text-field>
            </div>
          </div>
          <div class="B-carddetail marginTop">
            <div class="panal-title">Password</div>
            <div class="b-row">
              <v-text-field label="Password"></v-text-field>
            </div>
            <div class="b-row">
              <v-text-field label="Confirm Password"></v-text-field>
            </div>
          </div>
        </div>
      </div>
      <div class="line marginTop"></div>
    </div>
    <div id="userInfo" class="wrap-Main">
      <div class="box-S2">
        <div class="box-S4">
          <div class="N-Page T-size-24">Staff Personal Information</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail B-formMain">
            <div class="b-row">
              <div class="box-S2">
                <v-text-field label="Staff Code"></v-text-field>
              </div>
              <div class="box-S2">
                <v-text-field label="Title Name"></v-text-field>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S2">
                <v-text-field label="First Name"></v-text-field>
              </div>
              <div class="box-S2">
                <v-text-field label="Last Name"></v-text-field>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  label="Gender"
                ></v-select>
              </div>
              <div class="box-S2">
                <v-text-field label="Nationality"></v-text-field>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S2">
                <v-text-field label="Blood Group"></v-text-field>
              </div>
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  label="Crew Type"
                ></v-select>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  label="Position"
                ></v-select>
              </div>
              <div class="box-S2">
                <v-select
                  class="hideMessage"
                  label="Owner"
                ></v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S2">
        <div class="box-S4">
          <div class="N-Page T-size-24">Estimated Info.</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail B-formMain">
            <div class="b-row">
              <div class="box-S2">
                <v-text-field label="Weight (Kg.)"></v-text-field>
              </div>
              <div class="box-S2">
                <v-text-field label="Height (Cm.)"></v-text-field>
              </div>
            </div>
          </div>
        </div>
        <div class="box-S4">
          <div class="N-Page T-size-24">Contact Information</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail B-formMain">
            <div class="b-row">
              <div class="box-S2">
                <v-text-field label="ID Card/Passport No."></v-text-field>
              </div>
              <div class="box-S2">
                <v-text-field label="Email"></v-text-field>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S2">
                <v-text-field label="Phone No."></v-text-field>
              </div>
              <div class="box-S2">
                <v-text-field label="Mobile No."></v-text-field>
              </div>
            </div>
            <div class="b-row">
              <div class="box-S4">
                <v-textarea
                  label="Address"
                  hide-details
                  rows="2"
                ></v-textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div id="userInfo" class="wrap-Main">
      <div class="box-S4">
        <div class="N-Page T-size-24">Emergency Contact</div>
      </div>
      <div class="box-S4">
        <div class="B-carddetail B-formMain">
          <div class="b-row">
            <div class="box-S1-3">
              <v-text-field label="Name"></v-text-field>
            </div>
            <div class="box-S1-3">
              <v-text-field label="Relation"></v-text-field>
            </div>
            <div class="box-S1-3">
              <v-text-field label="Telephone No."></v-text-field>
            </div>
          </div>
        </div>
      </div>
      <div class="line marginTop"></div>
    </div>
    <div id="userInfo" class="wrap-Main">
      <div class="box-S4">
        <div class="N-Page T-size-24">Career</div>
      </div>
      <div class="box-S4">
        <div class="B-carddetail B-formMain">
          <div class="b-row">
            <div class="box-S1-3">
                <v-select
                  class="hideMessage"
                  label="Company"
                ></v-select>
            </div>
            <div class="box-S1-3">
              <v-text-field label="Department"></v-text-field>
            </div>
            <div class="box-S1-3">
              <v-text-field label="Job Position"></v-text-field>
            </div>
          </div>
        </div>
      </div>
      <div class="line marginTop"></div>
    </div>
    <div id="userInfo" class="wrap-Main">
      <div class="box-S2">
        <div class="box-S4">
          <div class="N-Page T-size-24">Certificate Expiration Date</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail B-formMain">
            <div class="b-row">
              <div class="box-S2">
                <v-menu
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      class="input-date"
                      v-model="depart_date"
                      label="Safety Training"
                      readonly
                      v-on="on"
                      append-icon="mdi-calendar-range"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="depart_date" :readonly=" readonly_eng || readonly_pilot" @input="menuselect_depart_date = false"></v-date-picker>
                </v-menu>
              </div>
              <div class="box-S2">
                <v-menu
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      class="input-date"
                      v-model="depart_date"
                      label="Medical Check Up"
                      readonly
                      v-on="on"
                      append-icon="mdi-calendar-range"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="depart_date" :readonly=" readonly_eng || readonly_pilot" @input="menuselect_depart_date = false"></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-S2">
        <div class="box-S4">
          <div class="N-Page T-size-24">Remark</div>
        </div>
        <div class="box-S4">
          <div class="B-carddetail B-formMain">
            <div class="b-row">
              <div class="box-S2">
                <v-text-field label="Locker No."></v-text-field>
              </div>
              <div class="box-S2">
                <v-text-field label="Remark"></v-text-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line marginTop"></div>
    </div>

    <div id="partSave" class="wrap-Main">
      <div class="box-S4">
        <div class="b-btnSave">
          <v-btn class="theme-btn-even btn-cancle Bsize150" :to="{ path: '/manageuser'}">
            <span class="T-size-18">Cancel</span>
          </v-btn>
          <v-btn class="theme-btn-even btn-save Bsize150" @click="dialogSave = true">
            <span class="I-save"></span>
            <span class="T-size-18">Save</span>
          </v-btn>
        </div>
        <div class="b-btnDelete" >
          <v-btn class="theme-btn-even btn-delete Bsize150" @click="dialogDelete = true">
            <span class="T-size-18">delete</span>
          </v-btn>
        </div>
      </div>
    </div>
    <div id="partBack" class="wrap-Main">
      <div class="line"></div>
      <div class="box-S4">
        <v-btn text class="ColorTheme-S white--text theme-btn" @click="GotoListBooking()">
          <span class="I-back"></span>
          <span>Back</span>
        </v-btn>
      </div>
    </div>
    
    <!-- dialog สำหรับ เพิ่ม แก้ไข -->

    <v-dialog v-model="dialogEvent" persistent max-width="400">
      <v-card id="dialog" class="TF type2">
        <div class="b-content">
          <div class="B-dialogform">
            <div class="t-namepage">{{formTitle}} Leg</div>
            <div class="b-form">
              <v-select
                class="hideMessage"
                :items="itemsListAirport"
                label="Airport"
                v-model="legs"
                item-text="ap_name"
                item-value="ap_id"
                return-object
              ></v-select>
              <div class="b-checkbox">
                <v-checkbox v-model="activity1" label="S/D Refuel"></v-checkbox>
                <v-checkbox v-model="activity2" label="S/D Refuel and HLO familiarize"></v-checkbox>
                <v-checkbox v-model="activity3" label="S/D FOR JET A1 INSPECTION"></v-checkbox>
                <v-checkbox v-model="activity4" label="EDRILL-1"></v-checkbox>
              </div>
            </div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialogEvent = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-save Bsize100" text @click="SaveLegs()">
              <span class="T-size-18">Save</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card id="dialog" class="TF type2">
        <div class="b-content">
          <div class="B-dialogform">
            <div class="t-namepage">Edit Leg</div>
            <div class="b-form">
              <v-select class="hideMessage" label="Airport"></v-select>
              <div class="b-checkbox">
                <v-checkbox v-model="activity1" label="S/D Refuel"></v-checkbox>
                <v-checkbox v-model="activity2" label="S/D Refuel and HLO familiarize"></v-checkbox>
                <v-checkbox v-model="activity3" label="S/D FOR JET A1 INSPECTION"></v-checkbox>
                <v-checkbox v-model="activity4" label="EDRILL-1"></v-checkbox>
              </div>
            </div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialog = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-save Bsize100" text @click="dialog = false">
              <span class="T-size-18">Save</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSave" persistent max-width="300">
      <v-card id="dialog" class="TF type1">
        <div class="b-content">
          <div class="B-dialog save">
            <div class="t-title">Confirm Save</div>
            <div class="t-des">Are you sure you want to save this item?</div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialogSave = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn
              class="theme-btn-even btn-save Bsize100"
              v-if="mode == 'Create'"
              text
              @click="CreateBooking()"
            >
              <span class="T-size-18">Save</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-save Bsize100" v-else text @click="SaveEditToDB()">
              <span class="T-size-18">Save Edit</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirm" persistent max-width="300">
      <v-card id="dialog" class="TF type1">
        <div class="b-content">
          <div class="B-dialog confirm">
            <div class="t-title">Save Complete</div>
            <div class="t-des">
              Save Data Complete
              <br />You want to Create Transport?
              <v-btn class="theme-btn-even btn-transport center Bsize190" @click="GotoCreateTransport()">
                <span class="I-transport"></span>
                <span class="T-size-18">Create Transport</span>
              </v-btn>
            </div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-ok Bsize100" text @click="GotoListBooking()">
              <span class="T-size-18">OK</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" persistent max-width="300">
      <v-card id="dialog" class="TF type1">
        <div class="b-content">
          <div class="B-dialog delete">
            <div class="t-title">Confirm Deletion</div>
            <div class="t-des">Are you sure you want to permanently delete this item?</div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialogDelete = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-delete Bsize100" text @click="DeleteBooking()">
              <span class="T-size-18">Delete</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import feathersClientUOA from "../plugins/feathers-client-uoa";
import { startOfDay, endOfDay, format } from "date-fns";
import fillerdate from "../utils/filterdate";
export default {
  name: "BookingDetail",
  data: () => ({
    mode: "",
    itemsDataBooking: [],
    itemsDataLegs: [],
    itemsListAirport: [],
    itemsListBookingType: [],
    itemsListCompany: [],
    chooseItemLegs: null,
    chooseItemLegIndex: null,
    listAddLegs: [],
    activity1: false,
    activity2: false,
    activity3: false,
    activity4: false,
    menuselectdate: false,
    menuselecttime:false,
    dialog: false,
    dialogEvent: false,
    dialogSave: false,
    dialogConfirm: false,
    loading: false,
    dialogDelete: false,
    modeEvent: "",
    flightno: "",
    company: "",
    date: "",
    time: "",
    bookingtype: "",
    departurefrom: "",
    legs: "",
    idbook: "",
    ref_id: "",
    userdata:"",
    dateNow:new Date(),
    ////////////////REPORT///////////////
    ArrListPassenger:[],
    ArrPassLeg_Out:[],
    ArrPassLeg_In:[],

  }),
  props: ["mode", "idbook"],
  async mounted() {
    this.userdata = JSON.parse(localStorage.getItem("user"));
    this.mode = this.$route.params.mode;
    this.idbook = this.$route.params.id;
    this.SelectListAircraft();
    this.SelectListBookingType();
    this.SelectListCompany();
    this.SelectListPassengerReport();
    if (this.mode == "Edit") {
      this.DataBookingFromDB();
      this.DataLegsFromDB();
      this.DataPassengerFromDB();
    }
  },
  computed: {
    formTitle() {
      return this.modeEvent === "create" ? "Add" : "Edit";
    }
  },
  methods: {
    async DataBookingFromDB() {
      try {
        var q = {};
        q.b_id = this.idbook;
        q.$eager = "[bookingstatus]"
        var res = await feathersClientUOA.service("booking").find({ query: q });
        this.itemsDataBooking = res.data[0];
        this.flightno = this.itemsDataBooking.f_no;
        this.company = this.itemsDataBooking.c_id;
        this.date = this.itemsDataBooking.b_departure_date.substring(0, 10);
        this.time = this.itemsDataBooking.b_departure_date.substring(11, 16);
        this.bookingtype = this.itemsDataBooking.bt_id;
        this.departurefrom = this.itemsDataBooking.ap_id;
        this.ref_id = this.itemsDataBooking.ref_id;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async DataLegsFromDB() {
      try {
        var q = {};
        q.b_id = this.idbook;
        q.$eager = "[airport]";
        q.retire = "0";
        var res = await feathersClientUOA
          .service("bookingleg")
          .find({ query: q });
        this.itemsDataLegs = res.data;
        this.itemsDataLegs.forEach(element => {
          var activity1 = false;
          if (element.bl_activity_1 == "1") {
            activity1 = true;
          } else {
            activity1 = false;
          }
          var activity2 = false;
          if (element.bl_activity_2 == "1") {
            activity2 = true;
          } else {
            activity2 = false;
          }
          var activity3 = false;
          if (element.bl_activity_3 == "1") {
            activity3 = true;
          } else {
            activity3 = false;
          }
          var activity4 = false;
          if (element.bl_activity_4 == "1") {
            activity4 = true;
          } else {
            activity4 = false;
          }
          var newArrayBinding = {};
          newArrayBinding["activity1"] = activity1;
          newArrayBinding["activity2"] = activity2;
          newArrayBinding["activity3"] = activity3;
          newArrayBinding["activity4"] = activity4;
          newArrayBinding["Idbookinglegs"] = element.bl_id;
          newArrayBinding["legs"] = element.airport;
          this.listAddLegs.push(newArrayBinding);
        });
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async DataPassengerFromDB() {
      try {
        await this.$refs.CompAddPassengerInbound.DataPassengerFromDB(
          this.idbook
        );
      } catch (error) {
        console.log(error);
      }
      try {
        await this.$refs.CompAddPassengerOutbound.DataPassengerFromDB(
          this.idbook
        );
      } catch (error) {
        console.log(error);
      }
    },
    async SelectListAircraft() {
      try {
        var q = {};
        q.retire = "0";
        var res = await feathersClientUOA.service("airports").find({ query: q });
        this.itemsListAirport = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async SelectListBookingType() {
      try {
        var res = await feathersClientUOA.service("bookingtype").find({});
        this.itemsListBookingType = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async SelectListCompany() {
      try {
        var res = await feathersClientUOA.service("company").find({});

        this.itemsListCompany = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async addItem() {
      this.modeEvent = "create";
      this.dialogEvent = true;
      this.legs = "";
      this.activity1 = false;
      this.activity2 = false;
      this.activity3 = false;
      this.activity4 = false;
    },
    async EditItem(itemlegs, index) {
      this.modeEvent = "edit";
      this.dialogEvent = true;
      this.legs = itemlegs.legs;
      this.activity1 = itemlegs.activity1;
      this.activity2 = itemlegs.activity2;
      this.activity3 = itemlegs.activity3;
      this.activity4 = itemlegs.activity4;
      this.chooseItemLegs = itemlegs;
      this.chooseItemLegIndex = index;
    },
    async deleteItem(itemlegs) {
      const index = this.listAddLegs.indexOf(itemlegs);
      if (index > -1) {
        this.listAddLegs.splice(index, 1);
      }
    },
    async SaveLegs() {
      if (this.modeEvent == "create") {
        var newArrayBinding = {};
        newArrayBinding["Idbookinglegs"] = null;
        newArrayBinding["activity1"] = this.activity1;
        newArrayBinding["activity2"] = this.activity2;
        newArrayBinding["activity3"] = this.activity3;
        newArrayBinding["activity4"] = this.activity4;
        newArrayBinding["legs"] = this.legs;
        this.listAddLegs.push(newArrayBinding);
      } else {
        var newArrayBinding = {};
        newArrayBinding["Idbookinglegs"] = this.listAddLegs[
          this.chooseItemLegIndex
        ].Idbookinglegs;
        newArrayBinding["activity1"] = this.activity1;
        newArrayBinding["activity2"] = this.activity2;
        newArrayBinding["activity3"] = this.activity3;
        newArrayBinding["activity4"] = this.activity4;
        newArrayBinding["legs"] = this.legs;
        this.listAddLegs[this.chooseItemLegIndex] = newArrayBinding;
      }

      this.dialogEvent = false;
    },
    async CreateBooking() {
      try {
        var querybooking = {};
        querybooking.b_departure_date = {
          $gt: format(startOfDay(new Date(this.date)), "yyyy-MM-dd HH:mm:ss"),
          $lt: format(endOfDay(new Date(this.date)), "yyyy-MM-dd HH:mm:ss")
        };
        var datacountbooking = await feathersClientUOA
          .service("booking")
          .find({ query: querybooking });
        let countbooking = datacountbooking.data.filter(
          x => x.b_departure_date.substr(0, 10) == this.date
        );
        let numref = 0;
        if (countbooking.length < 10) {
          numref = "000" + (parseInt(countbooking.length) + 1);
        } else {
          numref = "00" + (parseInt(countbooking.length) + 1);
        }
        this.ref_id = this.date.replace("-", "").replace("-", "") + numref;

        var DataAdd = {
          c_id: this.company.c_id,
          f_no: this.flightno,
          b_departure_date: this.date + " " + this.time,
          bt_id: this.bookingtype.bt_id,
          ap_id: this.departurefrom.ap_id,
          bs_id: 1,
          ref_id: this.ref_id,
          cb:this.userdata.FullName,
          cd: format(new Date(), "yyyy-MMM-dd HH:mm:ss")
        };

        //alert(JSON.stringify(DataAdd))
        var res = await feathersClientUOA.service("booking").create(DataAdd);
        this.idbook = res.b_id;
        this.CreateBookingLegsRawData(res.b_id);
        this.CreateBookingPassenger(res.b_id);
        this.dialogSave = false;
        this.dialogConfirm = true;
      } catch (error) {
        console.log(error);
      }
    },
    async CreateBookingLegsRawData(DataBooking) {
      try {
        this.listAddLegs.forEach(element => {
          var activity1 = 0;
          if (element.activity1 == true) {
            activity1 = 1;
          } else {
            activity1 = 0;
          }
          var activity2 = 0;
          if (element.activity2 == true) {
            activity2 = 1;
          } else {
            activity2 = 0;
          }
          var activity3 = 0;
          if (element.activity3 == true) {
            activity3 = 1;
          } else {
            activity3 = 0;
          }
          var activity4 = 0;
          if (element.activity4 == true) {
            activity4 = 1;
          } else {
            activity4 = 0;
          }
          var DataAdd = {
            bl_dest_airport_id: element.legs.ap_id,
            b_id: DataBooking,
            bl_activity_1: activity1,
            bl_activity_2: activity2,
            bl_activity_3: activity3,
            bl_activity_4: activity4
          };
          this.CreateBookingLegs(DataAdd);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async CreateBookingLegs(DataAdd) {
      //alert(JSON.stringify(DataAdd));
      try {
        var res = await feathersClientUOA.service("bookingleg").create(DataAdd);
      } catch (error) {
        console.log(error);
      }
    },
    async CreateBookingPassenger(DataBooking) {
      try {
        await this.$refs.CompAddPassengerInbound.CreateBookingPassengerRawData(
          DataBooking
        );
      } catch (error) {
        console.log(error);
      }
      try {
        await this.$refs.CompAddPassengerOutbound.CreateBookingPassengerRawData(
          DataBooking
        );
      } catch (error) {
        console.log(error);
      }
    },
    async SaveEditToDB() {
      var DataAdd = {
        c_id: this.company.c_id,
        f_no: this.flightno,
        b_departure_date: this.date + " " + this.time,
        bt_id: this.bookingtype.bt_id,
        ap_id: this.departurefrom.ap_id,
        mb:this.userdata.FullName,
        md:format(new Date(), "yyyy-MMM-dd HH:mm:ss"),
        bs_id:  this.itemsDataBooking.bs_id,
        b_submit_date: this.itemsDataBooking.b_submit_date,
        b_accept_date: this.itemsDataBooking.b_accept_date,
        b_approve: this.itemsDataBooking.b_approve,
        b_approve_date: this.itemsDataBooking.b_approve_date
      };
      var res = await feathersClientUOA
        .service("booking")
        .patch(this.idbook, DataAdd);
      this.SaveLegsEditToDB();
      try {
        await this.$refs.CompAddPassengerOutbound.SavePassengerEditToDB(
          this.idbook
        );
      } catch (error) {
        console.log(error);
      }
      try {
        await this.$refs.CompAddPassengerInbound.SavePassengerEditToDB(
          this.idbook
        );
      } catch (error) {
        console.log(error);
      }
  
      this.dialogSave = false;
      this.dialogConfirm = true;
    },
    async SaveLegsEditToDB() {
      var querybooking = {
        b_id: this.idbook
      };
      var res = await feathersClientUOA
        .service("bookingleg")
        .find({ query: querybooking });
      var DataAdd = {
        retire: 1
      };
      try {
        res.data.forEach(element => {
          this.Updatetodb(element.bl_id, DataAdd);
        });
      } catch (error) {
        console.log(error);
      }

      this.listAddLegs.forEach(elementUpdate => {
        if (elementUpdate.Idbookinglegs != null) {
          //alert(JSON.stringify(elementUpdate.Idbookinglegs));

          let dataUpdate = {
            bl_dest_airport_id: elementUpdate.legs.ap_id,
            bl_activity_1: elementUpdate.activity1 === false ? 0 : 1,
            bl_activity_2: elementUpdate.activity2 === false ? 0 : 1,
            bl_activity_3: elementUpdate.activity3 === false ? 0 : 1,
            bl_activity_4: elementUpdate.activity4 === false ? 0 : 1,
            retire: 0
          };
          //alert(JSON.stringify(dataUpdate));
          this.Updatetodb(elementUpdate.Idbookinglegs, dataUpdate);
        } else {
          let DataAdd = {
            bl_dest_airport_id: elementUpdate.legs.ap_id,
            b_id: this.idbook,
            bl_activity_1: elementUpdate.activity1 === false ? 0 : 1,
            bl_activity_2: elementUpdate.activity2 === false ? 0 : 1,
            bl_activity_3: elementUpdate.activity3 === false ? 0 : 1,
            bl_activity_4: elementUpdate.activity4 === false ? 0 : 1,
            retire: 0
          };

          //alert(JSON.stringify(DataAdd));
          this.CreateBookingLegs(DataAdd);
        }
      });
    },
    async Updatetodb(Idbookinglegs, dataUpdate) {
      try {
        await feathersClientUOA
          .service("bookingleg")
          .patch(Idbookinglegs, dataUpdate);
      } catch (error) {
        console.log(error);
      }
    },
    async DeleteBooking() {
      var DataEdit = {
        mb:this.userdata.FullName,
        md:format(new Date(), "yyyy-MMM-dd HH:mm:ss"),
        retire: 1
      };
      try {
        await feathersClientUOA.service("booking").patch(this.idbook, DataEdit);
        this.$router.push("/booking");
      } catch (error) {
        console.log(error);
      }
    },
    async closeDialog() {
      this.dialogEvent = false;
      this.dialogDelete = false;
      this.dialogConfirm = false;
      this.dialogSave = false;
    },
    async GotoListBooking() {
      this.closeDialog();
      this.$router.push("/booking");
    },
    async GotoCreateFlight() {
      this.$router.push({ path: `/FlightDetail/Create/${this.idbook}` })
    },
    async SelectListPassengerReport() {
      
      try {
        var q = {};
        q.b_id = this.idbook;
        var res = await feathersClientUOA.service("viewbookingpassenger").find({ query: q });
        this.ArrListPassenger= res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
      var tempLegsName_Out =''
      var tempLegsNameInter_Out =''
      var tempLegsName_In =''
      var tempLegsNameInter_In =''
      var PassOutRaw = this.ArrListPassenger.filter( x => x.pt_id == 1).filter( x => x.bp_inter_field != "1")
      var PassInRaw = this.ArrListPassenger.filter( x => x.pt_id == 2).filter( x => x.bp_inter_field != "1")

      var PassOutRaw_INTERRIG = this.ArrListPassenger.filter( x => x.pt_id == 1).filter( x => x.bp_inter_field == "1")
      var PassInRaw_INTERRIG = this.ArrListPassenger.filter( x => x.pt_id == 2).filter( x => x.bp_inter_field == "1")
      let No_Out = 1;
      let No_In = 1;

      let Body_weight_out = 0;
      let Body_weight_in = 0;
      let Baggage_weight_out = 0;
      let Baggage_weight_in = 0;
      
      

       PassOutRaw.forEach(element => {
       
          if(No_Out==1){
            
            this.ArrPassLeg_Out.push([{ text: "No.", style: "tablefontsize" },{ text: "Name-Surname", style: "tablefontsize" }, { text: "Designation", style: "tablefontsize" },{ text: "Company", style: "tablefontsize" },{ text: "Passport Number", style: "tablefontsize" }, { text: "Nationality", style: "tablefontsize" },{ text: "Body Weight (KG)", style: "tablefontsize" },{ text: "Luggage Weight (KG)", style: "tablefontsize" },{ text: "Tel No.", style: "tablefontsize" },{ text: "Department/Cost centre", style: "tablefontsize" },{ text: "CPOC OSP Yes/ No /Waiver", style: "tablefontsize" },{ text: "Survival Expiry date", style: "tablefontsize" },{ text: "Medical Expiry date", style: "tablefontsize" }])
            
          }
          
          if(tempLegsName_Out != element.ap_destairport_name){
            this.ArrPassLeg_Out.push([{ text: "", border: [true, false, false, false] }, { text: "MOBILIZE FROM :",color:'#29F21C ',fontSize: 8,border: [false, false, false, false]},{text: element.ap_departairport_name,color:'#29F21C ',fontSize: 10,border: [false, false, false, false] },{text: "TO :",color:'#29F21C ', fontSize: 8,border: [false, false, false, false] },{text: element.ap_destairport_name,color:'#29F21C ',fontSize: 10, border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, true, false] }])
            this.ArrPassLeg_Out.push([{ text: No_Out }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
            
          
            tempLegsName_Out = element.ap_destairport_name
            Body_weight_out += element.bp_body_weight
            Baggage_weight_out += element.bp_baggage_weight
          
          }else{
            this.ArrPassLeg_Out.push([{ text: No_Out }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
            Body_weight_out += element.bp_body_weight
            Baggage_weight_out += element.bp_baggage_weight
          
          }
       
        No_Out++
      });


      PassOutRaw_INTERRIG.forEach(element => {
      
        if(tempLegsNameInter_Out != element.ap_destairport_name){
            this.ArrPassLeg_Out.push([{ text: "", border: [true, false, false, false] }, { text: "INTER RIG FROM :",color:'#FF0000 ',fontSize: 8,border: [false, false, false, false]},{text: element.ap_departairport_name,color:'#FF0000',fontSize: 10,border: [false, false, false, false] },{text: "TO :",color:'#FF0000 ', fontSize: 8,border: [false, false, false, false] },{text: element.ap_destairport_name,color:'#FF0000 ',fontSize: 10, border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, true, false] }])
            this.ArrPassLeg_Out.push([{ text: No_Out }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
            
         
           tempLegsNameInter_Out = element.ap_destairport_name
           Body_weight_out += element.bp_body_weight
           Baggage_weight_out += element.bp_baggage_weight
          
         
        }else{
           this.ArrPassLeg_Out.push([{ text: No_Out }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
           Body_weight_out += element.bp_body_weight
           Baggage_weight_out += element.bp_baggage_weight
          
        }

        No_Out++

      });
       
        this.ArrPassLeg_Out.push([{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },  { text: "",  border: [false, false, false, false] },{ text: Body_weight_out,  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: Baggage_weight_out,  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "=", border: [false, false, false, false] },{ text: (Body_weight_out *2.2).toFixed(0),  fillColor:'#CBCACA',border: [true, true, true, true] },{ text: (Baggage_weight_out *2.2).toFixed(0) ,  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }])
        this.ArrPassLeg_Out.push([{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }, {text: "Total Weight", border: [false, false, false, false]},{ text: (Body_weight_out + Baggage_weight_out).toFixed(0),  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "KGS", fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "=", border: [false, false, false, false] },{ text: ((Body_weight_out *2.2) +(Baggage_weight_out *2.2)).toFixed(0),  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "LBS",  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }])
         
      ////////////Inbounb

       PassInRaw.forEach(element => {
       
          if(No_In==1){
            
            this.ArrPassLeg_In.push([{ text: "No.", style: "tablefontsize" },{ text: "Name-Surname", style: "tablefontsize" }, { text: "Designation", style: "tablefontsize" },{ text: "Company", style: "tablefontsize" },{ text: "Passport Number", style: "tablefontsize" }, { text: "Nationality", style: "tablefontsize" },{ text: "Body Weight (KG)", style: "tablefontsize" },{ text: "Luggage Weight (KG)", style: "tablefontsize" },{ text: "Tel No.", style: "tablefontsize" },{ text: "Department/Cost centre", style: "tablefontsize" },{ text: "CPOC OSP Yes/ No /Waiver", style: "tablefontsize" },{ text: "Survival Expiry date", style: "tablefontsize" },{ text: "Medical Expiry date", style: "tablefontsize" }])
            
          }
          
          if(tempLegsName_In != element.ap_destairport_name){
            this.ArrPassLeg_In.push([{ text: "", border: [true, false, false, false] }, { text: "MOBILIZE FROM :",color:'#29F21C ',fontSize: 8,border: [false, false, false, false]},{text: element.ap_departairport_name,color:'#29F21C ',fontSize: 10,border: [false, false, false, false] },{text: "TO :",color:'#29F21C ', fontSize: 8,border: [false, false, false, false] },{text: element.ap_destairport_name,color:'#29F21C ',fontSize: 10, border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, true, false] }])
            this.ArrPassLeg_In.push([{ text: No_In }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
            
          
            tempLegsName_In = element.ap_destairport_name
            Body_weight_in += element.bp_body_weight
            Baggage_weight_in += element.bp_baggage_weight
          
          // if
          }else{
            this.ArrPassLeg_In.push([{ text: No_In }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
            Body_weight_in += element.bp_body_weight
            Baggage_weight_in += element.bp_baggage_weight
          }
       
        No_In++
      });


      PassInRaw_INTERRIG.forEach(element => {
      
        if(tempLegsNameInter_In != element.ap_destairport_name){
            this.ArrPassLeg_In.push([{ text: "", border: [true, false, false, false] }, { text: "INTER RIG FROM :",color:'#FF0000 ',fontSize: 8,border: [false, false, false, false]},{text: element.ap_departairport_name,color:'#FF0000',fontSize: 10,border: [false, false, false, false] },{text: "TO :",color:'#FF0000 ', fontSize: 8,border: [false, false, false, false] },{text: element.ap_destairport_name,color:'#FF0000 ',fontSize: 10, border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }, { text: "", border: [false, false, true, false] }])
            this.ArrPassLeg_In.push([{ text: No_In }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
            
         
            tempLegsNameInter_In = element.ap_destairport_name
            Body_weight_in += element.bp_body_weight
            Baggage_weight_in += element.bp_baggage_weight
         
        }else{
            this.ArrPassLeg_In.push([{ text: No_In }, { text: element.u_firstname+' '+ element.u_lastname ,alignment: 'left'}, { text: element.u_jobposition },{ text: element.c_name },{ text: element.u_idcard_no },{ text: "THAI" },{ text: element.bp_body_weight },{ text:element.bp_baggage_weight },{ text:element.u_telephone },{ text: element.u_department },{ text: "YES" },{ text: format(new Date(element.u_safety_training), "dd-MMM-yy") }, { text: format(new Date(element.u_medical_checkup), "dd-MMM-yy") } ])
            Body_weight_in += element.bp_body_weight
            Baggage_weight_in += element.bp_baggage_weight
        }

        No_In++

      });
       
        this.ArrPassLeg_In.push([{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },  { text: "",  border: [false, false, false, false] },{ text: Body_weight_in,  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: Baggage_weight_in,  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "=", border: [false, false, false, false] },{ text: (Body_weight_in *2.2).toFixed(0),  fillColor:'#CBCACA',border: [true, true, true, true] },{ text: (Baggage_weight_in *2.2).toFixed(0) ,  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }])
        this.ArrPassLeg_In.push([{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }, {text: "Total Weight", border: [false, false, false, false]},{ text: (Body_weight_in + Baggage_weight_in).toFixed(0),  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "KGS", fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "=", border: [false, false, false, false] },{ text: ((Body_weight_in *2.2) +(Baggage_weight_in *2.2)).toFixed(0),  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "LBS",  fillColor:'#CBCACA', border: [true, true, true, true] },{ text: "", border: [false, false, false, false] },{ text: "", border: [false, false, false, false] }])
         




    },
    async Submit(){

      this.itemsDataBooking.bs_id = 2
      this.itemsDataBooking.b_submit_date = format(new Date(), "yyyy-MMM-dd HH:mm:ss")
     
    },
    async Accept(){
      this.itemsDataBooking.bs_id = 3
      this.itemsDataBooking.b_accept_date = format(new Date(), "yyyy-MMM-dd HH:mm:ss")
      this.itemsDataBooking.b_approve = this.userdata.FullName
      this.itemsDataBooking.b_approve_date = format(new Date(), "yyyy-MMM-dd HH:mm:ss")
     
    },
    Booking_Report(){
       var pdfMake = require("../../public/js/pdfmake");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("../../public/js/vfs_fonts");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
     
         var docDefinition = {
        pageOrientation: "landscape",
        pageMargins: [ 40, 20, 20, 20 ],
        content: [
          {
            table: {
               widths: [ 10,90,50,50,60,40,40,50,50,50,50,50,50],
              body: [
                [{text:"CARIGALI PTTEPI OPERATING COMPANY - HELICOPTER / VESSEL BOOKING FORM", style: "tableHeader",colSpan: 13, alignment: "center" }, "", "", "",  "",  "",  "", "", "",  "",  "",  "",  "" ],
                [{text: "TO",colSpan: 6,border: [true, false, false, false] },{ text: "" },{ text: "" },{ text: "" },{ text: "" },{ text: "" },{text: "Request Ref :", colSpan: 3,border: [true, false, false, false] }, { text: "" },{ text: "" },{ text: "" ,colSpan: 2,border: [false, false, false, false]}, { text: "" },  {rowSpan: 3 ,colSpan: 2,border: [false, false, true, false],alignment: 'center' ,margin: [0, 7.5, 0, 0],width: 25,height: 18,image: 'data:image/jpeg;base64,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'},{ text: "" } ],
                [{text: "CC",colSpan: 6, border: [true, false, false, false]},{ text: "" },{ text: "" },{ text: "" },{ text: "" },{ text: "" }, {text: "Date Prepared :", colSpan: 3,border: [true, false, false, false]},{ text: "" },{ text: "" },{ text: format(new Date(), "EEEE,dd MMMM,yyyy") ,alignment: 'center' ,colSpan: 2,border: [false, false, false, false]}, { text: "" },{text: ""}, { text: "" }],
                [{text: "", colSpan: 6, border: [true, false, false, false] },{ text: "" }, { text: "" }, { text: "" }, { text: "" }, { text: "" },{text: "No. of Pages :", colSpan: 3, border: [true, false, false, false] },{ text: "" },{ text: "" },{ text: "" ,colSpan: 2,border: [false, false, false, false]}, { text: "" },  { text: "" },{ text: "" }],
                [{text: "",border: [true, true, false, true]},{ text: "Travel Date", style: "tablefontsize" },{ text: "SKL Helicopter", style: "tablefontsize" },{ text: "KBR Helicopter", style: "tablefontsize" },{ text: "SKL Vessel", style: "tablefontsize" }, { text: "KSB Vessel", style: "tablefontsize" },{text: "Remarks :", colSpan: 7,border: [true, true, true, true]},{ text: "" },{ text: "" },{ text: "" },{text: "" },{ text: "" },{ text: "" }],
                [{text: "",border: [true, true, false, false]},{ text: format(new Date(this.itemsDataBooking.b_departure_date), "EEEE,dd MMMM,yyyy"), color:"red", style: "tablefontsize" ,border: [true, true, false, false]},{ text: this.flightno, color:"red", style: "tablefontsize" ,border: [true, true, false, false]},{ text: "", border: [true, true, false, false]},{ text: "",border: [true, true, false, false]},{text: "",colSpan:8, border: [true, true, true, false] },{ text: "",  }, { text: "" },{ text: "" },{ text: "" },{ text: "" },{ text: "" },{ text: "" }],
               
              ]
            }
          },
          {
            style:'tableExample',
            table: {
              widths: [ 10,90,50,50,60,40,40,50,50,50,50,50,50],
              body: this.ArrPassLeg_Out
            }
          },

           {
            style:'tableExample',
            table: {
              widths: [ 10,90,50,50,60,40,40,50,50,50,50,50,50],
              body: this.ArrPassLeg_In
            },margin: [0,10, 0, 5]
          },
        
          {
            table: {
              widths: [100, "*", "*"],
              body: [
                
                [
                  {
                    rowSpan: 2,
                    text: "Prepared By",
                    fontSize: 6,
                    alignment: "right",
                    border: [false, false, false, false]
                  },
                  {
                    text: "Shore Co CPOC ",
                    fontSize: 6,
                    alignment: "center",
                    border: [false, false, false, false]
                  },
                  { rowSpan: 2, text: "", border: [false, false, false, false] }
                ],
                [
                  { text: "", border: [false, false, false, false] },
                  {
                    text:
                      "Helicopter Booking Procedures SSP ref: POD GEMP 00014 - Appendix 3, Rev 1 April 02",
                    fontSize: 4,
                    alignment: "center",
                    border: [false, false, false, false]
                  },
                  { text: "", border: [false, false, false, false] }
                ]
              ]
            }
          }
        ],
        styles: {
          header: {
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 8,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            fontSize: 6,
            alignment: "center"
          },
          tableHeader: {
            bold: true,
            fontSize: 6,
            color: "black",
            alignment: "center"
          },
          tablefontsize: {
            fontSize: 6,
            alignment: "center"
          }
        },
        defaultStyle: {
          // alignment: 'justify'
          fontSize: 6,
        }
      };


        pdfMake.createPdf(docDefinition).download("Booking_Report.pdf");
    },
   
     async GotoCreateTransport() {
      try {
      
        this.$router.push({ path: `/TransportDetail/Create/${this.idbook}` });
      } catch (error) {
        console.log(error);
      }
    }
   
  }
};
</script>

<style>
</style>
